export default __webpack_public_path__ + "static/media/outsource_main.761cc457.jpg";